// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"67":"365cc670","211":"cce7e299","228":"6192c9f1","534":"d6c2eaa9","596":"a6cba8e1"}[chunkId] + ".css";
};